<span *ngIf="menuItem.showAnimatedDot" class="bulb-onboarding-badge bulb-onboarding-badge-pulsate bulb-onboarding-badge-header"></span>
<a
  *ngIf="menuItem.type === 'LINK'"
  href="{{ menuItem.link }}"
  target="_blank"
  role="menuitem"
  class="bulb-menu-item-container"
  [style.color]="menuItem.color"
  [ngClass]="{'bulb-menu-item-container--disabled' : menuItem.disabled}"
>
  <bulb-menu-item [menuItem]="menuItem"></bulb-menu-item>
</a>
<a role="button" (click)="onDisabledAction($event, menuItem)">
  <button
    *ngIf="menuItem.type !== 'LINK'"
    [disabled]="menuItem.disabled"
    (click)="menuItem.command($event); menuItemClicked.emit({ $event, menuItem })"
    class="bulb-menu-item-container"
    [style.color]="menuItem.color"
    [ngClass]="{'bulb-menu-item-container--disabled' : menuItem.disabled}"
    role="menuitem"
  >
    <bulb-menu-item [menuItem]="menuItem"></bulb-menu-item>
  </button>
</a>
